import { StandaloneServiceType } from './type'
import Visual from './Visual'

const StandaloneService = ({ services, address }: StandaloneServiceType) => {
  return <Visual address={address} services={services} />
}

export default StandaloneService
